export default "__VITE_PUBLIC_ASSET__70fbe7f0__"